// Public routing only. Credentials and identity data never belong in this registry.
export const ROOMS = [
  { id: 'reception', hostname: 'reception.meta.easyteach.cloud', port: 3000, world: 'world' },
  { id: 'meetingroom', hostname: 'meetingroom.meta.easyteach.cloud', port: 3001, world: 'world-meetingroom' },
  { id: 'auditorium', hostname: 'auditorium.meta.easyteach.cloud', port: 3002, world: 'world-auditorium' },
  { id: 'showroom', hostname: 'showroom.meta.easyteach.cloud', port: 3003, world: 'world-showroom' },
  { id: 'courseroom', hostname: 'courseroom.meta.easyteach.cloud', port: 3004, world: 'world-courseroom' },
]

// Independent identity domains are deliberately excluded from Saratoga room travel/default origins.
export const ISOLATED_ROOMS = [
  { id: 'tuft', hostname: 'tuft.meta.easyteach.cloud', port: 3005, world: 'world-tuft' },
]

export function getRoom(id) {
  const room = [...ROOMS, ...ISOLATED_ROOMS].find(room => room.id === id)
  if (!room) throw new Error('Unknown room')
  return room
}
